import { fetchBaseQuery, createApi } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../../admin/Constant";

export const ThemeApi = createApi({
  reducerPath: "ThemeApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${API_URL}/themes` }),
  endpoints: (builder) => ({
    createTheme: builder.mutation({
      query: (data) => ({
        url: "create",
        method: "POST",
        body: data,
      }),
    }),
    allTheme: builder.query({
      query: () => ({
        url: "all",
        method: "GET",
      }),
    }),
    getThemeById: builder.query({
      query: (slug) => ({
        url: `detail/${slug}`,
        method: "GET",
      }),
    }),
    updateTheme: builder.mutation({
      query: ({ slug, data }) => ({
        url: `update/${slug}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteTheme: builder.mutation({
      query: (id) => ({
        url: `delete/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAllThemeQuery,
  useCreateThemeMutation,
  useGetThemeByIdQuery,
  useUpdateThemeMutation, 
  useDeleteThemeMutation 
} = ThemeApi;
